module.exports = __webpack_public_path__ + "static/media/creategame.f597cb2e.png";